import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import styles from "./AdminDashboardPage.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faBars, 
  faSignOutAlt, 
  faChevronDown,
  faCoins,
  faHistory,
  faSearch,
  faExchangeAlt,
  faPlusCircle,
  faGift,
  faTicketAlt,
  faMobileAlt,
  faTicket,
  faRoute,
  faUserTie,
  faCheckCircle,
  faCar,
  faTrash,
  faTags,
  faUsers,
  faHeadset,
  faFileExcel,
  faDatabase,
} from "@fortawesome/free-solid-svg-icons";
import CustomerHistory from "./CustomerHistory";
import RedeemPoints from "./RedeemPoints";
import TransactionHistory from "./TransactionHistory";
import AddPoint from "./AddPoint";
import { ToastContext } from "~/components/context/ToastContext";
import { ModalContext } from "~/components/context/ModalContext";
import { useNavigate } from "react-router-dom";
import { BASE_AUTH_URL } from "~/helper/apiService";
import DriverManager from "~/page/DriverManager";
import CheckInManager from "../CheckInManager/CheckInManager";
import WashManager from "../WashManager";
import ImageManager from "../ImageManager";
import PromotionManagement from "../PromotionManagement";
import RewardManagement from "../RewardManagement";
import PromotionLinkManagement from "../PromotionLinkManagement";
import VoucherManagement from "../VoucherManagement";
import TripsManagement from "../TripsManagement";
import UserManagement from "../UserManagement";
import CareListPage from "../CustomerCare/CareListPage";
import CareAgainPage from "../CustomerCare/CareAgainPage";
import StatisticsPage from "../CustomerCare/StatisticsPage";
import ReturnStatusPage from "../CustomerCare/ReturnStatusPage";
import CareHistoryPage from "../CustomerCare/CareHistoryPage";
import SheetManagement from "../SheetManagement/SheetManagement";
import AutoInsertVehicles from "./AutoInsertVehicles";
// import RevenueLogs from "./RevenueLogs";

const cx = classNames.bind(styles);

const DatXePromotionLinks = () => <PromotionLinkManagement initialTab="links" />;
const DatXePromotionStats = () => <PromotionLinkManagement initialTab="stats" />;

const menu = {
  pointManagement: {
    label: "Quản lý điểm",
    icon: faCoins,
    items: [
      {
        key: "TransactionHistory",
        label: "Lịch sử giao dịch",
        component: <TransactionHistory />,
        protected: true,
        icon: faHistory,
      },
      {
        key: "CustomerHistory",
        label: "Tra cứu",
        component: <CustomerHistory />,
        icon: faSearch,
      },
      {
        key: "RedeemPoints",
        label: "Đổi điểm",
        component: <RedeemPoints />,
        protected: true,
        icon: faExchangeAlt,
      },
      {
        key: "AddPoint",
        label: "Thêm điểm",
        component: <AddPoint />,
        icon: faPlusCircle,
      },
    ],
  },
  promotions: {
    label: "Ưu đãi",
    icon: faTags,
    items: [
      {
        key: "PromotionManagement",
        label: "Giờ vàng",
        component: <PromotionManagement />,
        icon: faGift,
      },
      {
        key: "RewardManagement",
        label: "Quay thưởng",
        component: <RewardManagement />,
        icon: faTicketAlt,
      },
    ],
  },
  datxe: {
    label: "Đặt xe",
    icon: faCar,
    items: [
      {
        key: "DatXePromotionLinks",
        label: "Link khuyến mại",
        component: <DatXePromotionLinks />,
        icon: faTags,
      },
      {
        key: "DatXePromotionStats",
        label: "Thống kê",
        component: <DatXePromotionStats />,
        icon: faTags,
      },
    ],
  },
  customerCare: {
    label: "Chăm sóc khách hàng",
    icon: faHeadset,
    items: [
      {
        key: "CareListPage",
        label: "Danh Sách Cần Chăm Sóc",
        component: CareListPage,
        icon: faHeadset,
      },
      {
        key: "CareHistoryPage",
        label: "Lịch sử chăm sóc",
        component: CareHistoryPage,
        icon: faHistory,
      },
      {
        key: "ReturnStatusPage",
        label: "Thống Kê Quay Lại",
        component: ReturnStatusPage,
        icon: faHeadset,
      },
      {
        key: "CareAgainPage",
        label: "Chăm Sóc Lại Lần 2",
        component: CareAgainPage,
        icon: faHeadset,
      },
      {
        key: "StatisticsPage",
        label: "Thống Kê",
        component: StatisticsPage,
        icon: faHeadset,
      },
    ],
  },
  system: {
    label: "Hệ thống",
    icon: faUsers,
    items: [
      {
        key: "UserManagement",
        label: "Quản lý User",
        component: <UserManagement />,
        icon: faUsers,
      },
      {
        key: "SheetManagement",
        label: "Quản lý Sheet",
        component: <SheetManagement />,
        icon: faFileExcel,
      },
      {
        key: "AutoInsertVehicles",
        label: "Tự động Insert Số Xe",
        component: <AutoInsertVehicles />,
        icon: faDatabase,
      },
      // {
      //   key: "RevenueLogs",
      //   label: "Log doanh thu",
      //   component: <RevenueLogs />,
      //   icon: faListAlt,
      // },
    ],
  },
  mobileApp: {
    label: "Mobile App",
    icon: faMobileAlt,
    items: [
      {
        key: "VoucherAppManagement",
        label: "Voucher",
        component: <VoucherManagement />,
        icon: faTicket,
      },
      {
        key: "TripsManagement",
        label: "Chuyến đi",
        component: <TripsManagement />,
        icon: faRoute,
      },
    ],
  },
  driver: {
    label: "Tài xế",
    icon: faUserTie,
    items: [
      {
        key: "DriverManager",
        label: "Tài xế",
        component: <DriverManager />,
        icon: faUserTie,
      },
      {
        key: "CheckInManager",
        label: "Check-in",
        component: <CheckInManager />,
        icon: faCheckCircle,
      },
      {
        key: "WashManager",
        label: "Rửa xe",
        component: <WashManager />,
        icon: faCar,
      },
      {
        key: "DeleteImages",
        label: "Dọn ảnh",
        component: <ImageManager />,
        icon: faTrash,
      },
    ],
  },
};

// Helper function để tìm item theo key (đặt ngoài component để có thể dùng trong initialization)
const getItemByKey = (key) => {
  if (!key) return null;
  for (const groupKey in menu) {
    const item = menu[groupKey].items.find((i) => i.key === key);
    if (item) return item;
  }
  return null;
};

function AdminDashboardPage() {
  // Load từ localStorage hoặc dùng giá trị mặc định
  const getStoredActiveTab = () => {
    const stored = localStorage.getItem("adminActiveTab");
    if (stored) {
      // Kiểm tra xem tab có tồn tại trong menu không
      const item = getItemByKey(stored);
      if (item) {
        return stored;
      }
    }
    return "TransactionHistory";
  };

  const getStoredExpandedGroups = () => {
    const stored = localStorage.getItem("adminExpandedGroups");
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (e) {
        return {
          pointManagement: true,
          promotions: true,
          datxe: true,
          mobileApp: true,
          driver: true,
          system: true
        };
      }
    }
    return {
      pointManagement: true,
      promotions: true,
      datxe: true,
      mobileApp: true,
      driver: true,
      system: true
    };
  };

  const [activeTab, setActiveTab] = useState(getStoredActiveTab);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expandedGroups, setExpandedGroups] = useState(getStoredExpandedGroups);
  const { showToast } = useContext(ToastContext);
  const { showModal } = useContext(ModalContext);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await fetch(`${BASE_AUTH_URL}check-login`, {
          credentials: "include",
        });
        if (response.ok) {
          const data = await response.json();
          localStorage.setItem("user", JSON.stringify(data.user));
          if (data.user.role === "admin") {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
            navigate("/login");
          }
        } else {
          setIsAuthenticated(false);
          localStorage.removeItem("user");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error checking auth:", error);
        localStorage.removeItem("user");
        setIsAuthenticated(false);
        navigate("/login");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  const handleLogout = async () => {
    try {
      const response = await fetch(`${BASE_AUTH_URL}logout`, {
        method: "POST",
        credentials: "include",
      });
      const data = await response.json();
      if (response.ok) {
        showToast(data.message, "success");
        setIsAuthenticated(false);
        setActiveTab("TransactionHistory");
        navigate("/login");
      } else {
        showToast(data.error || "Đăng xuất thất bại", "error");
      }
    } catch (error) {
      showToast("Lỗi kết nối: " + error.message, "error");
    }
  };

  const confirmLogout = () => {
    showModal({
      title: "Xác Nhận Đăng Xuất",
      message: "Bạn có chắc chắn muốn đăng xuất?",
      onConfirm: handleLogout,
      onCancel: null,
    });
  };

  const handleTabChange = (key) => {
    const item = getItemByKey(key);
    if (item && item.protected && !isAuthenticated) {
      showToast("Vui lòng đăng nhập để truy cập tính năng này", "error");
      navigate("/login");
    } else {
      setActiveTab(key);
      localStorage.setItem("adminActiveTab", key);
      setIsSidebarOpen(false);
    }
  };

  const toggleGroup = (groupKey) => {
    setExpandedGroups((prev) => {
      const newState = {
        ...prev,
        [groupKey]: !prev[groupKey],
      };
      localStorage.setItem("adminExpandedGroups", JSON.stringify(newState));
      return newState;
    });
  };

  // Sync expandedGroups với localStorage khi thay đổi
  useEffect(() => {
    localStorage.setItem("adminExpandedGroups", JSON.stringify(expandedGroups));
  }, [expandedGroups]);

  if (loading) {
    return <div className={cx("loading")}>Đang kiểm tra xác thực...</div>;
  }

  const currentItem = getItemByKey(activeTab);

  return (
    <div className={cx("container")}>
      <button
        className={cx("hamburger", { active: isSidebarOpen })}
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <FontAwesomeIcon icon={faBars} className={cx("hamburger-icon")} />
      </button>
      <div
        className={cx("overlay", { active: isSidebarOpen })}
        onClick={() => setIsSidebarOpen(false)}
      ></div>
      <div className={cx("sidebar", { open: isSidebarOpen })}>
        <h2 className={cx("sidebar-title")}>Admin</h2>
        <ul className={cx("sidebar-menu")}>
          {Object.keys(menu).map((groupKey) => (
            <>
              <li
                key={`header-${groupKey}`}
                className={cx("group-header")}
                onClick={() => toggleGroup(groupKey)}
              >
                <FontAwesomeIcon icon={menu[groupKey].icon} className={cx("group-icon")} />
                <span>{menu[groupKey].label}</span>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={cx("chevron-icon", { expanded: expandedGroups[groupKey] })}
                />
              </li>
              <ul
                key={`submenu-${groupKey}`}
                className={cx("submenu", { open: expandedGroups[groupKey] })}
              >
                {menu[groupKey].items.map((item) => (
                  <li
                    key={item.key}
                    className={cx("sidebar-item", { active: activeTab === item.key })}
                    onClick={() => handleTabChange(item.key)}
                  >
                    {item.icon && (
                      <FontAwesomeIcon icon={item.icon} className={cx("item-icon")} />
                    )}
                    {item.label}
                  </li>
                ))}
              </ul>
            </>
          ))}
          {isAuthenticated && (
            <li className={cx("sidebar-item")} onClick={confirmLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} style={{ marginRight: "10px" }} />
              Đăng Xuất
            </li>
          )}
        </ul>
      </div>
      <div className={cx("content")}>
        <h1 className={cx("title")}>{currentItem?.label}</h1>
        {currentItem?.component && (
          React.isValidElement(currentItem.component)
            ? currentItem.component
            : React.createElement(currentItem.component)
        )}
      </div>
    </div>
  );
}

export default AdminDashboardPage;